import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import axios from "../../axios-vmou";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import styles from "../invalidcopies/copy.module.css";
import Navbar from "../main/navbar";
import logo from "../../assets/vmou.png";
import { Sidebar } from 'primereact/sidebar';
import * as actions from '../../store/actions/index'
import { useHistory } from "react-router-dom";

const Extracopies = (props) => {
  const [visibleRight, setVisibleRight] = useState(false);
  const onSignout = () => {
    props.onlogout();
  }
  let emptycopy = {
    ccode:'',
    noofcopies: "",
  };

  const [currBatch, setcurrBatch] = useState('');
  const [copy, setcopy] = useState(emptycopy);
  const [copies, setCopies] = useState([]);
  const [selectedcopies, setSelectedcopies] = useState(null);
  const [copyDialog, setcopyDialog] = useState(false);
  const [deletecopyDialog, setDeletecopyDialog] = useState(false);

  const [mode, setMode] = useState("");

  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const history = useHistory();

  useEffect(() => {
    if (history.location.state.batch) setcurrBatch(history.location.state.batch);
    let authOptions = {
      method: "PUT",
      url: "/extra/getbybatch",
      data: history.location.state.batch,
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
    .then((response) => {
      console.log(response.data);
      setCopies(response.data);
    })
    .catch((error) => {
      toast.current.show({
        severity: "error",
        summary: "Error Message",
        detail: error.response.data,
      });
      setCopies([]);
    });

  }, [history.location.state.batch]); 

  const openNew = () => {
    setcopy(emptycopy);
    setSubmitted(false);
    setMode("New");
    setcopyDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setcopyDialog(false);
  };

  const hideDeletecopyDialog = () => {
    setDeletecopyDialog(false);
  };

  const savecopy = () => {
    setSubmitted(true);
    let authOptions="";
    if (copy.ccode === currBatch.ccode) {
      toast.current.show({
        severity: "error",
        summary: "Failed",
        detail: "Course Code is SAME as Batch...Use Invalid Copies Option",
        life: 3000,
      });
      return;
    }
    if (copy.ccode.trim() && copy.noofcopies>0) {
      let _cp = { ...copy };
      let _copy = {
        exam : currBatch.exam,
        occode : currBatch.ccode,
        batchcode: currBatch.batchcode,
        ccode: _cp.ccode,
        noofcopies: _cp.noofcopies,
        userid: currBatch.userid,
        examinerid:currBatch.examinerid,
        dteval: '',
        dtvmou: '',
        copiesrecd: 0,
        awlrecd: false,
        marksentered: false
    
      }
      if (mode === "Edit") {
        const index = findIndexById(_copy.ccode);
        if (index >=0) {
          
          authOptions = {
            method: "PUT",
            url: "/extra/",
            data: _copy,
            headers: {
              "x-auth-token": localStorage.getItem("token"),
            },
          };
        } else {
          authOptions = {
            method: "POST",
            url: "/extra/",
            data: _copy,
            headers: {
              "x-auth-token": localStorage.getItem("token"),
            },
          };
        }
        axios(authOptions)
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Extra copy Edited",
              life: 3000,
            });
            let ncp = [...copies];
            const i = ncp.findIndex(e => e.ccode === copy.ccode);
            ncp[i] = _copy;
            setCopies(ncp);
            setcopyDialog(false);
          })
          .catch((error) => {
            toast.current.show({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data,
            });
          });
      } else {
        const i = copies.find(x => x.ccode === _copy.ccode );
        if (i) {
          toast.current.show({
            severity: "error",
            summary: "Error Message",
            detail: "This Course Code Already Entered",
          });
          return;
        }
        let authOptions = {
          method: "POST",
          url: "/extra/",
          data: _copy,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        };
        axios(authOptions)
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "copy Created",
              life: 3000,
            });
            let ncp = [...copies]
            ncp.push(_copy)
            setCopies(ncp);
            setcopyDialog(false);
          })
          .catch((error) => {
            toast.current.show({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data,
            });
          });
      }
    }
    else {
      toast.current.show({
        severity: "error",
        summary: "Failed",
        detail: "Either No Course Code OR Nil No of Copies",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < copies.length; i++) {
      if (copies[i].ccode=== id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const editcopy = (copy) => {
    setcopy({ ...copy });
    setMode("Edit");
    setcopyDialog(true);
  };

  const confirmDeletecopy = (copy) => {
    setcopy(copy);
    setDeletecopyDialog(true);
  };

  const deletecopy = () => {
    let authOptions = {
      method: "put",
      url: "/extra/delete/",
      data: {'batchcode':currBatch.batchcode, 'ccode':copy.ccode},
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
        let _copies = copies.filter(val => val.ccode !== copy.ccode);
        setCopies(_copies);
        setDeletecopyDialog(false);
        setcopy(emptycopy);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Extra copy Entry Deleted",
          life: 3000,
        });
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
      });
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _copy = { ...copy };
    _copy[`${name}`] = val.toUpperCase();
    setcopy(_copy);
  };
  const onInputChangeNo = (e, name) => {
    const val = (e.value) || 0;
    let _copy = { ...copy };
    _copy[`${name}`] = val;
    setcopy(_copy);
  };


  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button-success p-mr-2"
          onClick={openNew}
        />
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
      </React.Fragment>
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-text p-button-success p-mr-2"
          onClick={() => editcopy(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-text p-button-warning"
          onClick={() => confirmDeletecopy(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className={styles.tableheader}>
      <h4 className="mx-0 my-1">Manage Extra Copies</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
    </div>
  );
  const copyDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        className="p-button-text"
        onClick={savecopy}
      />
    </React.Fragment>
  );
  const deletecopyDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeletecopyDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deletecopy}
      />
    </React.Fragment>
  );


  return (
    <div className={styles.datatablecruddemo}>
      <Toast ref={toast} />
      <Sidebar className="flex align-items-center " visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <h2>User Profile....</h2>
          <h5>Examiner ID : {props.email}</h5>
          <h5>Name        : {props.username}</h5>
          <Button className="p-button-text p-button-danger ml-4" style={{}} onClick={onSignout}>Sign Out</Button>
        </Sidebar>
      <div className="Headerusr" style={{ position: "sticky" }}>
        <img
          src={logo}
          alt="VMOU"
          height={100}
          width={90}
          style={{ margin: "0px 0 0 20px" }}
        ></img>
        <h2 style={{ marginTop: "0", textAlign: "center" }}>
          Examiner Module
          <br />
          {'Extra Copies for Batch : '+history.location.state.batch.batchcode}
        </h2>
        <div className="Userusr" onClick={(e) => setVisibleRight(true)}>
          <i style={{'fontSize': '1.5em'}} className="pi pi-user mr-6 mt-2 text-right"></i>
          <h4 style={{margin:'0 30px 0 0',textAlign:'end'}} >Hi, {props.username}</h4>
        </div>
      </div>
      <Navbar />
      <div style={{width:'40%', margin:'auto'}} className={styles.card}>
        <Toolbar
          className="p-mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>

        <DataTable
          resizableColumns
          columnResizeMode="fit"
          showGridlines
          className="p-datatable-sm"
          ref={dt}
          value={copies}
          selection={selectedcopies}
          onSelectionChange={(e) => setSelectedcopies(e.value)}
          dataKey="ccode"
          sortField="ccode"
          sortOrder={1}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} copies"
          globalFilter={globalFilter}
          header={header}
          responsiveLayout="scroll"
        >
          <Column
            field="ccode"
            header="Course Code"
            sortable
            style={{ width: "30%" , textAlign:"center",padding:'0 1px 0 4px' }}
          ></Column>
          <Column
            field="noofcopies"
            header="No of Copies"
            style={{ width: "30%"  , padding:'0 1px 0 1px'}}
          ></Column>
          <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{  padding:'0 1px 0 1px'}}
          ></Column>
        </DataTable>
        <div className='mt-2' style={{textAlign:'center'}}>            
          <Button label="Back"  className="p-button-rounded p-button-danger" onClick={()=>history.goBack()} />
        </div>
      </div>

      <Dialog
        visible={copyDialog}
        style={{ width: "450px" }}
        header="Extra Copy Details"
        modal
        className="p-fluid"
        footer={copyDialogFooter}
        onHide={hideDialog}
      >
        <div className="p-field">
          <label >Course Code*</label>
          <InputText
            value={copy.ccode}
            onChange={(e) => onInputChange(e, "ccode")}
            required
            className={classNames({
              "p-invalid": submitted && !copy.ccode,
            })}
          />
          {submitted && !copy.ccode && (
            <small className="p-error">Course Code is required.</small>
          )}
        </div>
        <div className="p-field">
          <label >No of Copies*</label>
          <InputNumber
            value={copy.noofcopies}
            min={1}
            max={1000}
            onChange={(e) => onInputChangeNo(e, "noofcopies")}
            required
            className={classNames({ "p-invalid": submitted && !copy.noofcopies })}
          />
          {submitted && !copy.noofcopies && (
            <small className="p-error">No of Copies is required.</small>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={deletecopyDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={deletecopyDialogFooter}
        onHide={hideDeletecopyDialog}
      >
        <div className={styles.confirmationcontent}>
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {copy && (
            <span>
              Are you sure you want to Delete <b>{copy.ccode}</b>?
            </span>
          )}
        </div>
      </Dialog>

    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    userid: state.auth.userid,
    email: state.auth.email,
    isAuth: state.auth.token !== null,
  };
};

const mapDispatchToProps = dispatch => {
  return {
      onlogout:() => dispatch(actions.logout())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Extracopies);